import { render, staticRenderFns } from "./SocialHistory.vue?vue&type=template&id=4ebdff4f&scoped=true"
import script from "./SocialHistory.vue?vue&type=script&lang=js"
export * from "./SocialHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebdff4f",
  null
  
)

export default component.exports